
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's182ab2d6c997515f': `Додајте га на Home Screen за широке могућности и лак приступ.`,
's224cbcec014ef6b5': `Притисните Share у навигационој траци`,
's37a9e8aec5713460': `Више`,
's386eca8362ff6155': `Притисните Више ако нема иконе за дељење`,
's4e1e10a6ca408245': `Додирните "Add to Home Screen"`,
's6196153c4b0c1ea0': `Инсталирај`,
's633502f7cff4f847': `Отворите мени вашег прегледача`,
's681e399d63311fba': `Прикажи галерију`,
's7f0591f08e318eda': `Притисните Више у Share менију`,
's8114bd55cae5a22b': `3) Притисните Add to Dock`,
's9af56bf005b49c74': `Померите се надоле до "Add to Home Screen"`,
'sa5ef80b4bb9b39f8': `Мање`,
'sba52286c21552a4e': `Инсталирајте га на вашем уређају за широке могућности и лак приступ.`,
'sc16e00a7a8b2fde2': `Назад`,
'se0e473adfda8066c': `Отворите у вашем главном прегледачу`,
'se740f75b95a51807': `Додајте га у вашу Dock за широке могућности и лак приступ.`,
'sfea652f6580ff086': `Овај сајт има функционалност апликације.`,
's922329d6f6213590': `Add to Dock`,
'scdaf4bbff76674c8': `Add to Home Screen`,
    };
  